export var SoapCommentsOldKey;

(function (SoapCommentsOldKey) {
  SoapCommentsOldKey["dr_comment"] = "dr_comment";
  SoapCommentsOldKey["pre_rd_comment"] = "pre_rd_comment";
  SoapCommentsOldKey["post_rd_comment"] = "post_rd_comment";
  SoapCommentsOldKey["pharmacist_comment"] = "pharmacist_comment";
  SoapCommentsOldKey["nurse_comment"] = "nurse_comment";
  SoapCommentsOldKey["dietician_comment"] = "dietician_comment";
})(SoapCommentsOldKey || (SoapCommentsOldKey = {}));

export var SoapCommentsKey;

(function (SoapCommentsKey) {
  SoapCommentsKey["dr_comments"] = "dr_comments";
  SoapCommentsKey["pre_rd_comments"] = "pre_rd_comments";
  SoapCommentsKey["post_rd_comments"] = "post_rd_comments";
  SoapCommentsKey["pharmacist_comments"] = "pharmacist_comments";
  SoapCommentsKey["nurse_comments"] = "nurse_comments";
  SoapCommentsKey["dietician_comments"] = "dietician_comments";
})(SoapCommentsKey || (SoapCommentsKey = {}));

export var SoapType;

(function (SoapType) {
  SoapType["flc_first"] = "flc_first";
  SoapType["NUTRITIONAL_SUPPLEMENT"] = "NUTRITIONAL_SUPPLEMENT";
  SoapType["NUTRITIONAL_SUPPLEMENT_FOLLOW_UP"] = "NUTRITIONAL_SUPPLEMENT_FOLLOW_UP";
  SoapType["NUTRITIONAL_CONSULTATION"] = "NUTRITIONAL_CONSULTATION";
  SoapType["NUTRITIONAL_CONSULTATION_FOLLOW_UP"] = "NUTRITIONAL_CONSULTATION_FOLLOW_UP";
  SoapType["PSYCHOLOGICAL_COUNSELING"] = "PSYCHOLOGICAL_COUNSELING";
  SoapType["PSYCHOLOGICAL_COUNSELING_FOLLOW_UP"] = "PSYCHOLOGICAL_COUNSELING_FOLLOW_UP";
  SoapType["CLINIC_NUTRITIONAL_COUNSELING"] = "CLINIC_NUTRITIONAL_COUNSELING";
})(SoapType || (SoapType = {}));

export var ActionButtonTypes;

(function (ActionButtonTypes) {
  ActionButtonTypes["Clinic"] = "Clinic";
  ActionButtonTypes["ConsultMain"] = "ConsultMain";
  ActionButtonTypes["ConsultSub"] = "ConsultSub";
})(ActionButtonTypes || (ActionButtonTypes = {}));

export var SOAP_KIND;

(function (SOAP_KIND) {
  SOAP_KIND["CLINIC"] = "CLINIC";
  SOAP_KIND["RD"] = "RD";
})(SOAP_KIND || (SOAP_KIND = {}));

export var PlanType;

(function (PlanType) {
  PlanType["input"] = "input";
  PlanType["tag"] = "tag";
  PlanType["fasting_derail"] = "fasting_derail";
  PlanType["weight_moderate"] = "weight_moderate";
  PlanType["targetPercent"] = "targetPercent";
  PlanType["targetWeight"] = "targetWeight";
  PlanType["currentHeight"] = "currentHeight";
  PlanType["currentWeight"] = "currentWeight";
})(PlanType || (PlanType = {}));